import React from "react";
import { createPortal } from "react-dom";
import { Loader } from "../loader";

function FullScreenLoader() {
  return createPortal(
    <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none before:absolute before:flex before:bg-black/25 before:w-full before:h-full z-[999999]">
      <Loader />
    </div>,
    document.getElementById("root")
  );
}

export default FullScreenLoader;
